const config = {
    // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '/',
    defaultPath: '/dashboard',
    fontFamily: `'Poppins', sans-serif`,
    borderRadius: 12,
    cookieUserName: 'USER',
    cookieCompanyId: 'HR-COMPANY-SECURE',
    cookieToken: 'HR-SECURE',
    cookieUserID: 'HR-USER-SECURE',
    cookieUser: 'HR-USER'
};

export default config;
